import { useContext, useEffect, useState } from 'react';
import TempSubmittedFounderDashboard from './FounderDashboards/TempSubmittedDashboard';
import ApprovedFounderDashboard from './FounderDashboards/ApprovedFounderDashboard';
import TempPendingFounderDashboard from './FounderDashboards/PendingFounderDashboard';
import RejectedFounderDashboard from './FounderDashboards/RejectedFounderDashboard';
import UnsubmittedFounderDashboard from './FounderDashboards/UnsubmittedFounderDashboard';
import SubmittedFounderDashboard from './FounderDashboards/SubmittedFounderDashboard';
import ExpertInviteDashboard from './FounderDashboards/ExpertInviteDashboard';
import ExpertMetDashboard from './FounderDashboards/ExpertMetDashboard';
import { AuthContext, AuthContextType, LangContext, LangContextType, useAsync } from '../../utilities/customHooks';
import { getfounderDashboardDetails } from '../../services/founderService';
import LoadingIndicator from '../../Components/LoadingIndicator';
import ErrorIndicator from '../../Components/ErrorIndicator';
import * as T from "../../utilities/frontendTypes";
import PreSowDashboard from './FounderDashboards/PreSowDashboard';
import { checkUrlAndModifySpan } from '../../utilities/helperFunctions';
import ReviewSowFromProviderDashboard from './FounderDashboards/ReviewSowFromProviderDashboard';
import SowDashboard from './FounderDashboards/PreSowDashboard';
import TempRejectedReapplyFounderDashboard from './FounderDashboards/TempRejectedReapplyFounderDashboard';
import TempEditRequestFounderDashboard from './FounderDashboards/TempEditRequestFounderDashboard';
import SelectSpfFounderDashboard from './FounderDashboards/SelectSpfFounderDashboard';
import PendingSpfFounderDashboard from './FounderDashboards/PendingSpfFounderDashaboard';
import TempApprovedFounderDashboard from './FounderDashboards/TempApprovedFounderDashboard';
import TempUnsubmittedFounderDashboard from './FounderDashboards/TempUnsubmittedFounderDashboard';

function FounderDashboard() {
  const [isViewingPastProjects, setIsViewingPastProjects] = useState(false);
  const [reload, setReload] = useState(false);
  const [viewingSow, setViewingSow] = useState<T.Statement>();
  const [appArrayPosition, setAppArrayPosition] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState(true)
  const { langState, setLang } = useContext(LangContext) as LangContextType


  const handleChildStatusChange = () => {
    setReload(!reload);
    setViewingSow(undefined)
  };
  // const { memberApplicationStatus } = useContext(AuthContext) as AuthContextType;
  const founderDashboardDetailsAsync = useAsync(() => getfounderDashboardDetails(), [viewingSow, reload]);

  if (founderDashboardDetailsAsync.status === "pending") {
    return <LoadingIndicator />;
  }

  if (founderDashboardDetailsAsync.status === "rejected") {
    return <ErrorIndicator />;
  }

  const foundDeat = founderDashboardDetailsAsync.value.dashboardDetails;
  const userRegion = foundDeat.userRegion
  const appArray = foundDeat.applications
  let completedProjects: T.Project[] = []
  let inProgressProjects: T.Project[] = []

    if (foundDeat.projects && foundDeat.projects.length > 0) {
      foundDeat.projects.forEach(project => {
        if (
            project.projectStatus === "completed" ||
            project.projectStatus === "payment requested" ||
            project.projectStatus === "paid"
        ) {
            completedProjects.push(project);
        }
        if (
            project.projectStatus === "requested" ||
            project.projectStatus === "submitted" ||
            project.projectStatus === "preSignature" ||
            project.projectStatus === "signed"
        ) {
            inProgressProjects.push(project);
        }
      });  
    }    

  if (inProgressProjects.length === 1 && inProgressProjects[0].statements.length === 1 && !viewingSow?.sowId) {
    setViewingSow(inProgressProjects[0].statements[0])
  } 

  const handleViewingSow = (sowId: string) => {
    if (foundDeat.projects && foundDeat.projects.length > 0) {
        for (const project of foundDeat.projects) {
          if (project.statements && Array.isArray(project.statements)) {
            for (const statement of project.statements) {
              if (statement.sowId === sowId) {
                setViewingSow(statement)
              }
            }
          }
        }
      }
    }

  const multipleCurrentSowsHtml = () => {
  if (inProgressProjects && inProgressProjects.length > 0) { 
    return inProgressProjects[0].statements.map((statement, index) => (
    <button className={viewingSow?.sowId === statement.sowId ? `font-semibold underline bodyLarger` : `underline bodyLarger`} onClick={() => handleViewingSow(statement.sowId)}>Statement of Work {index + 1}</button>
  ))} else {
    return <></>
  }
}

  const menuFix = () => {
      const menu = document.getElementsByClassName('sideMenu');
      Array.from(menu).forEach(element => {
        element.classList.add('sideMenuCollapsed');
      });
      const hide = document.getElementsByClassName('mobileHide');
      Array.from(hide).forEach(element => {
        element.classList.add('profileHide');
      });
      const headerhide = document.getElementsByClassName('profilePageHide');
      Array.from(headerhide).forEach(element => {
        element.classList.add('profileHide');
      });
    }
  
      const currentUrl = window.location.pathname; 
      checkUrlAndModifySpan(currentUrl)
      if (currentUrl === '/dashboard/profile' || currentUrl.includes('/dashboard/memberships')) {
        menuFix();
      } else if (currentUrl === '/dashboard/program-details') {
        const menu = document.getElementsByClassName('sideMenu');
        Array.from(menu).forEach(element => {
          element.classList.remove('sideMenuCollapsed');
        });
        const hide = document.getElementsByClassName('mobileHide');
        Array.from(hide).forEach(element => {
          element.classList.remove('profileHide');
        });
        const headerhide = document.getElementsByClassName('profilePageHide');
        Array.from(headerhide).forEach(element => {
          element.classList.add('profileHide');
        });
      } else {
        const menu = document.getElementsByClassName('sideMenu');
        Array.from(menu).forEach(element => {
          element.classList.remove('sideMenuCollapsed');
        });
        const hide = document.getElementsByClassName('mobileHide');
        Array.from(hide).forEach(element => {
          element.classList.remove('profileHide');
        });
        const headerhide = document.getElementsByClassName('profilePageHide');
        Array.from(headerhide).forEach(element => {
          element.classList.remove('profileHide');
        });
      }
      console.log(appArray, userRegion)
    const getFounderDashboardByApplicationStatus = () => {
      if (appArray && appArray.length > 0) {
        if (userRegion === "investOttawa" || userRegion === "northForge") {
          return <TempApprovedFounderDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} />;
        } else {
          switch (appArray[appArrayPosition].status) {
            case "n/a":
            case "approved":
              return <TempSubmittedFounderDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} />;
            case "pending":
            case "submitted":
            case "ddInProgress":
            case "rejectedFlagged":
            case "rejectedInProgress":
            case "awaitingIpe":
            case "growthCoachInvite":
            case "growthCoachInProgress":
            case "growthCoachRecommendation":
              return <SubmittedFounderDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} />;
            case "rejectedReapply":
              return <RejectedFounderDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} />;
            case "pendingEditRequest":
                return <TempEditRequestFounderDashboard companyNameForDashboard={foundDeat.companyName} />;        
            case "rejected":        
              return <RejectedFounderDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} />;
            case "unsubmitted":
              return <UnsubmittedFounderDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} midApplication={foundDeat.midApplication} />;
            case "ipExpertInvite":
              return <ExpertInviteDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} />;
            case "ipExpertInProgress":
            case "ipeBoardReview":
            case "ipExpertRecommendation":
              return <ExpertMetDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} />;
            case "selectSpf":
              return <SelectSpfFounderDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} onStatusChange={handleChildStatusChange}/>;
            case "newSpfRequested":
              return <PendingSpfFounderDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} />;  
            case "sowRequested":
            case "sowAwaitingApproval":
            case "sowAwaitingStartupApproval":
            case "sowAwaitingAdminApproval":
            case "sowEditRequested":
              return <SowDashboard companyNameForDashboard={appArray[appArrayPosition].profileSnapshot.companyInfo?.basicInfo?.operatingName || foundDeat.companyName} percentage={inProgressProjects[0].coPayPercentage.toString()} firm={inProgressProjects[0].spName} sow={viewingSow} onStatusChange={() => handleChildStatusChange()}/>;
            default:
              throw new Error('Unknown Application Status');
          }
        }
      } else {
        if (userRegion === "investOttawa" || userRegion === "northForge") {
          return <TempUnsubmittedFounderDashboard companyNameForDashboard={foundDeat.companyName} midApplication={foundDeat.midApplication} />;
        } else {
          return <UnsubmittedFounderDashboard companyNameForDashboard={foundDeat.companyName} midApplication={foundDeat.midApplication} />;
        }
      }
  }

  return (
    <div>
      {isModalOpen && userRegion !== "investOttawa" &&
        <div className='largeModal'>
          <div className='largeModalInner !h-fit !w-fit'>
            <div className='flex justify-end w-full'>
              <button onClick={() => setIsModalOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9M1 1L9 9" stroke="#1A2E25" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>  
            {langState === "eng"
            ?
            <div className='bodyLarger'>
              <p className='mb-2'>Thank you for your interest in the ElevateIP program. Please note that as of July 1st, 2025, our application window will be closed as we assess applicants.</p>
              <p className='mb-2'>We invite you to continue building your IP knowledge through our <a className='underline' href='https://elevateip-learninghub.communitech.ca/' target='_blank'>ElevateIP Learning Hub.</a></p>
              <p className='mb-2'>We’re proud of the impact ElevateIP has made—and we’re actively working with our funders to help ensure this support continues for Canadian startups.</p>
              <p className='mb-2'>For any questions, please reach out to <a className='underline' href='mailto:elevateip@communitech.ca' target='_blank'>elevateip@communitech.ca</a></p> 
            </div>
            : 
            <div className='bodyLarger'>
              <p className='mb-2'>Nous vous remercions de l’intérêt que vous portez à ÉleverlaPI. Veuillez noter que dès le 1er juillet 2025, nous évaluons le cohorte actuel et nous n’acceptons aucune nouvelle demande.</p>
              <p className='mb-2'>Nous vous invitons à développer vos connaissances en matière de propriété intellectuelle grâce à notre <a className='underline' href='https://elevateip-learninghub.communitech.ca/' target='_blank'>Centre d'apprentissage ÉleverlaPI.</a></p>
              <p className='mb-2'>Nous sommes fiers de ce qu'ÉleverlaPI a produit jusqu'à présent. Pour l'avenir, nous travaillons avec nos bailleurs de fonds pour assurer que ce type de soutien reste disponible pour les startups.</p>
              <p className='mb-2'>Pour toute question, veuillez nous contacter à <a className='underline' href='mailto:elevateip@communitech.ca' target='_blank'>elevateip@communitech.ca</a></p> 
            </div>
            }
          </div>  
        </div>  
      }
      {
        appArray && appArray.length > 1 &&
          <div>
          {/* {appArray.map} */}
          </div>
      }
      {
        completedProjects.length > 0 &&
        <div>
          <h3>{isViewingPastProjects ? "Current Projectds" : "Past Projects"}</h3>
        </div>
      }
      {
        isViewingPastProjects &&
        <div>
          {completedProjects.map((project, index) => (
            <div key={project._id}>
              <button>Project {index + 1}</button>
            </div>
            ))
          }
        </div>
      }
      {
        !isViewingPastProjects && inProgressProjects && inProgressProjects.length > 0 ?
      <div>
        {inProgressProjects[0].statements.length > 1 &&
        <div className='dashboardCont !flex-row mb-4'>
          {multipleCurrentSowsHtml()}
        </div>
        }
        {getFounderDashboardByApplicationStatus()}
      </div>
      :
      <div>
        {getFounderDashboardByApplicationStatus()}
      </div>
      }
      </div>
  )
}

export default FounderDashboard